import { all, fork } from "redux-saga/effects";

//public
import AuthSaga from "./auth/login/saga";
import ForgetSaga from "./auth/forgetpwd/saga";
import ProfileSaga from "./auth/profile/saga";
import LayoutSaga from "./layout/saga";
import eventsSaga from "./events/saga";
import usersSaga from "./users/saga";
import reportsSaga from "./reports/saga";
import feedbackSaga from "./feedback/saga";
import thomasSaga from "./thomas/saga";

export default function* rootSaga() {
  yield all([
    //public
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    fork(LayoutSaga),
    fork(eventsSaga),
    fork(usersSaga),
    fork(reportsSaga),
    fork(feedbackSaga),
    fork(thomasSaga),
  ]);
}
